import { useParams } from "react-router-dom-v5-compat";
import { useFetchPackageReservationQuery } from "../store/api";

export const usePackageReservationDetailPage = () => {
  const params = useParams<{ reservationId: string }>();

  const { data, isLoading, isError } = useFetchPackageReservationQuery({
    hopperReservationId: params.reservationId ?? "",
  });

  return {
    isLoading,
    isError,
    itinerary: data?.itinerary,
  };
};
